<div class="legend-element">

  <svg width="8px" height="16px">
    <line 
      [attr.x1]="2" 
      [attr.x2]="2" 
      [attr.y1]="0" 
      [attr.y2]="16" 
      [style.stroke]="color"
      [style.stroke-dasharray]="dash"
      [style.stroke-width]="'2px'"/>
  </svg>
  <span class="device-name">{{name}}</span>
</div>